export const DOCUMENT_OPTIONS = [
	{
		label: 'Identity card',
		value: 'Scan/Good quality photo of identity card',
	},
	{
		label: 'Act de identitate',
		value: 'Act de identitate (Copie)',
	},
	{
		label: 'Diplomă de facultate',
		value: 'Copie diploma ultima institutie de invătamânt absolvita',
	},
	{
		label: 'Certificat de medic',
		value:
			'Adeverintã de la un medic de medicina muncii care confirmã angajarea',
	},
	{
		label: 'Workbook photo',
		value: 'Scan/Good quality photo of your workbook',
	},
	{
		label: "Doctor's Certificate",
		value: "Doctor's certificate (required before the start date).",
	},
];
